import { render, staticRenderFns } from "./StepperItem.vue?vue&type=template&id=2c3912d0&scoped=true"
import script from "./StepperItem.vue?vue&type=script&lang=js"
export * from "./StepperItem.vue?vue&type=script&lang=js"
import style0 from "./StepperItem.vue?vue&type=style&index=0&id=2c3912d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3912d0",
  null
  
)

export default component.exports